const cmpRichText = {
  component: null,

  init: function (element) {
    const _ = this
    _.component = element
  }

}

export default cmpRichText
